import { useEffect } from 'react';
import AOS from 'aos';
import ServiceCard from '../ui/ServiceCard';
import {
  FaGlobe,
  FaRegWindowMaximize,
  FaReact,
  FaPlug,
  FaDesktop, 
  FaPaintBrush,
  FaCogs,
  FaCloud
} from 'react-icons/fa';

const services = [
  {
    icon: FaGlobe,
    title: 'Business Website Development',
    description: 'Professional websites tailored for your business needs.',
    features: [
      'Responsive design',
      'SEO optimized',
      'Contact forms',
      'Analytics integration',
    ],
  },
  {
    icon: FaRegWindowMaximize,
    title: 'Landing Page Development',
    description: 'High-converting landing pages for products and campaigns.',
    features: [
      'Fast loading',
      'Conversion focused',
      'A/B test ready',
      'Mobile optimized',
    ],
  },
  {
    icon: FaReact,
    title: 'MERN Stack Web Application',
    description: 'Full-stack applications with MongoDB, Express, React, Node.',
    features: [
      'Scalable architecture',
      'RESTful APIs',
      'Authentication system',
      'Database design',
    ],
  },
  {
    icon: FaDesktop,
    title: 'Custom Admin Dashboard',
    description: 'Powerful dashboards for managing your business data.',
    features: [
      'Real-time analytics',
      'User management',
      'Data visualization',
      'Role-based access',
    ],
  },
  {
    icon: FaPlug,
    title: 'REST API Development',
    description: 'Robust and secure APIs for your applications.',
    features: [
      'Clean documentation',
      'Rate limiting',
      'JWT authentication',
      'Error handling',
    ],
  },
  {
    icon: FaPaintBrush,
    title: 'UI Implementation (React)',
    description: 'Pixel-perfect UI components built with React.',
    features: [
      'Component library',
      'Reusable code',
      'Animations',
      'Accessibility',
    ],
  },
  {
    icon: FaCogs,
    title: 'Website Maintenance',
    description: 'Ongoing support and updates for your website.',
    features: [
      'Bug fixes',
      'Security updates',
      'Performance optimization',
      'Content updates',
    ],
  },
  {
    icon: FaCloud,
    title: 'Deployment & Hosting',
    description: 'Secure deployment and hosting setup for your projects.',
    features: [
      'CI/CD pipelines',
      'SSL certificates',
      'Cloud hosting',
      'Domain setup',
    ],
  },
];

const HeroSection = () => {
  useEffect(() => {
      AOS.refresh();
      AOS.init({
        duration: 1500,
        once: true,
      })
    }, []);

  return (
    <header className="header align-items-start flex-column h-auto" id="hero">
      <div className="overlay"></div>
      <div className="service-head d-flex flex-column justify-content-center align-items-center mb-5" data-aos="fade-up">
        <div className="header-content" data-aos="fade-up">
          <h1 className="projects-title">My Services</h1>
          <p className="header-subtitle text-center">What I Do?</p>
          <p className="header-description text-center">
            Helping businesses and startups build modern, responsive, and scalable web applications using the MERN Stack.
          </p>
        </div>

        <div className="projects-items mx-5 mt-4">
          <div className="row">
            {services.map((service, index) => (
              <ServiceCard
                key={index}
                icon={service.icon}
                title={service.title}
                description={service.description}
                features={service.features}
                delay={index * 50}
              />
            ))}
          </div>
        </div>
      </div>
    </header>
  );
};

export default HeroSection;